(ns graph-ui.web.draft
  "Client-side editor drafts for the Studio live preview — PLAN-graph-ui-v0-006-01
   §Phase 5b, ADR-ikc-v3-050-01.

   The description :text-area publishes its buffer here on every (debounced)
   change, under a key of [session-id source]; the :island-view preview widget
   derefs the same key reactively and re-renders the parsed tree AS YOU TYPE.

   Purely client-side: a draft is UNSAVED editor text, never island state. It
   never touches the bus — the buffer only reaches the server when the composer
   presses Apply (:ui/apply-widget-tree). So a half-typed, invalid description
   lives here harmlessly; the preview falls back to the saved tree meanwhile.

   Each draft is {:text raw :parsed tree | :error message}. Parsing happens on
   WRITE so the reader (a reagent render, hot path) never parses; an unparseable
   buffer keeps no :parsed and carries :error, which the preview surfaces."
  (:require [reagent.core :as r]
            [clojure.string :as str]
            [cljs.reader :as reader]))

;; @feature F-graph-ui-v0-001-01-ui-quality-system
;; @adr ADR-ikc-v3-050-01-studio-self-hosting

(defonce ^:private drafts (r/atom {}))

(defn- k [session-id source] [(str session-id) source])

(defn set-draft!
  ;; CONCEPT: CONCEPT-graph-ui-v0-001-01-three-graphs
  "Publish editor buffer `text` for [session-id source]. Parses eagerly: a valid
   EDN form becomes {:text :parsed}, anything else {:text :error}. Blank text
   clears the draft, so the preview falls back to the saved island."
  [session-id source text]
  (let [key (k session-id source)]
    (if (str/blank? text)
      (swap! drafts dissoc key)
      (let [result (try {:parsed (reader/read-string text)}
                        (catch :default e {:error (or (.-message e) "unparseable")}))]
        (swap! drafts assoc key (merge {:text text} result))))))

(defn draft
  ;; CONCEPT: CONCEPT-graph-ui-v0-001-01-three-graphs
  "Reactive read of the draft for [session-id source], or nil when none is
   published. Deref happens inside @drafts, so calling this in a reagent render
   re-renders that component whenever the editor buffer changes."
  [session-id source]
  (get @drafts (k session-id source)))
